/**
 * Normalize a user-entered website/link into an absolute http(s) URL safe for
 * `href`. Values without a scheme (e.g. "codesparks.com.np") get `https://`
 * prepended so the link opens the actual site instead of a relative path.
 * Returns null for empty input or non-http(s) schemes (e.g. "javascript:").
 */
export function normalizeHttpUrl(value: string | null | undefined): string | null {
  if (value == null) return null;
  const trimmed = value.trim();
  if (trimmed === '') return null;
  const candidate = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  try {
    const parsed = new URL(candidate);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return null;
    return parsed.toString();
  } catch {
    return null;
  }
}
